import { BreakerApplication } from 'unitData/Breaker/BreakerTypes';
import type { UnitInfoGyratoryCrusherCGInterface } from 'store/units/types';
import { BaseUnitConfig } from 'unitData/BaseUnitConfig';

export class GyratoryCrusherCGConfig extends BaseUnitConfig {
  static getDefaultData(): UnitInfoGyratoryCrusherCGInterface {
    return {
      modelName: 'CG810i',
      unitThrow: 33,
      oss: 150,
      ...BaseUnitConfig.getBaseDefaults(),
      grizzly: false,
      showCustomModel: false,
      decks: { 0: { separationSize: 125 } },
      bypass: 50,
      attachmentTool: {
        boom: undefined,
        breaker: undefined,
        powerPack: undefined,
        enabled: false,
        application: BreakerApplication.GYRATORY,
      },
      display: {
        ...BaseUnitConfig.getDefaultDisplay(),
        displayLoad: true,
        displayRiskLevel: false,
        displayOss: true,
        displayUnitThrow: true,
        displaySeparationSize: false,
        displayAttachmentTool: false,
      },
    };
  }

  static getNumberOfPorts(): number {
    return 2;
  }
}

export const gyratoryCrusherCGConfig = new GyratoryCrusherCGConfig();

export const getNominalCapacity = (
  volumeCapacities: number[],
  oss: number | undefined,
) => {
  const limitVals = [
    114.3, 127, 139.7, 152.4, 165.1, 177.8, 190.5, 203.2, 215.9, 228.6, 241.3,
    254, 266.7,
  ];
  const conversionFactor = 1.1023;
  if (volumeCapacities?.length === limitVals.length && oss !== undefined) {
    let i = 0;
    do {
      i++;
    } while (oss >= limitVals[i] && i < limitVals.length);
    if (i < limitVals.length) {
      return Math.round(
        (volumeCapacities[i] -
          ((volumeCapacities[i] - volumeCapacities[i - 1]) /
            (limitVals[i] - limitVals[i - 1])) *
            (limitVals[i] - oss)) /
          conversionFactor,
      );
    }
  }
  return 0;
};
